import { useTranslation } from 'react-i18next';

import { usePlanEditor } from './editor';

import { DrawerBackButton } from '@/components/ui';

/**
 * The Planning drawer's heading, on the row with the collapse chevron
 * (2026-09-25, the pilot's ask): "Project summary" while the plan-vs-budget
 * section is what the rail shows, "Task summary" with the way back to the
 * project beside it while a task is selected (2026-09-28). One title style
 * for both, so the row reads the same whichever mode the rail is in. The
 * back button used to sit on a condensed "Project total" band that no longer
 * exists; it keeps its automation id. Since 2026-10-01 (the pilot's ask) it
 * reads "Show project summary" with the overview glyph, not "← Project", and
 * sits right after the title rather than at the row's far end. Since
 * 2026-10-08 (the pilot's ask) it is styled as a button — larger, on a light
 * blue fill with a blue outline — so it no longer reads as a tag. Since 3 Nov
 * (Mette) the row carries the back button alone, or nothing in the project
 * view: both views' titles moved into the panel as `SidePanelHeading`, the
 * Project Portfolio's — the task's name, or "Project summary". The button is
 * `ui/DrawerBackButton` since 3 Nov, shared with Financials' contract view.
 */
export const PlanDrawerHeading = () => {
  const { state, dispatch } = usePlanEditor();
  const { t } = useTranslation('pmCommon');

  if (state.activeId) {
    return (
      <DrawerBackButton
        label={t('term.ShowProjectSummary')}
        onClick={() => dispatch({ type: 'SET_ACTIVE', id: null })}
        automationId="task-insight-back"
      />
    );
  }

  // The project view's title is in the panel, like the task's (3 Nov).
  return null;
};
